import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as bootstrap from 'bootstrap';
import { AuthProvider } from './contexts/AuthProvider';
import ErrorBoundary from './components/ErrorBoundary';
import store from './store';
import App from './App';
import './styles/print.css'; // global print rules (hide app chrome + on-page buttons in print)
// import './styles/custom-zindex.css'; // Tambahkan ini

// You'd need to add styles here or import them in your HTML

if (typeof window !== 'undefined') {
  window.bootstrap = window.bootstrap || bootstrap;

  // Defensively unregister any previously-installed service worker and
  // clear its caches. The CRA template no longer ships a SW, but if one
  // was ever registered it would keep serving stale assets and prevent
  // fresh deploys from showing up. Safe no-op when none exists.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    }).catch(() => {});
  }
  if (typeof window.caches !== 'undefined' && window.caches?.keys) {
    window.caches.keys().then((keys) => {
      keys.forEach((k) => window.caches.delete(k));
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
); 
